// Copyright (c) Jeff Steinbok. All rights reserved.
// Licensed under the MIT License. See LICENSE in the project root for license information.

/**
 * Public TestFlight invitation for the Jeffpardy iOS app.
 *
 * TestFlight regenerates these links when a build group changes, so this is the
 * single place to update it. The QR code on the /ios landing page is generated
 * from this value by tools/generate-testflight-qr.mjs -- re-run that script
 * after changing the URL.
 */
export const TestFlightUrl = "https://testflight.apple.com/join/bakcPktu";

/** Landing page describing the iOS app. Short enough to read aloud or print. */
export const IosAppPath = "/ios";
